import { signInWithRedirect } from 'aws-amplify/auth';

// Routes the user through Cognito's Hosted UI via Amplify's OAuth flow.
// v6 validates a `state` parameter on the return trip that only exists if
// Amplify itself initiated the redirect — so we must go through
// signInWithRedirect rather than constructing the /login URL by hand.
export function redirectUnauthedUser() {
  signInWithRedirect();
}
